<div class="content">
    <mat-form-field class="example-full-width">
        <mat-label>Observações</mat-label>
        <textarea [(ngModel)]="message" matTextareaAutosize matAutosizeMinRows=5 matAutosizeMaxRows=5 matInput value=""></textarea>
    </mat-form-field>
    <div class="action">
        <button class="btn" mat-raised-button coloy="primary" (click)="onNoClick()">Cancelar</button>
        <button class="btn" mat-raised-button coloy="primary" (click)="finalizar()">Finalizar</button>
    </div>
</div>